
import searchMutations from './mutations/searchMutations'
import selectedProductMutations from './mutations/selectedProductMutations'
import storesMutations from './mutations/storesMutations'
import usersMutations from './mutations/usersMutations'
import vouchersMutations from './mutations/vouchersMutations'

export default {
    ...searchMutations, 
    ...selectedProductMutations,
    ...storesMutations,  
    ...usersMutations, 
    ...vouchersMutations,
}


// WEBPACK FOOTER //
// ./assets/js/vue/store/mutations.js